/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { JobDetailsApiModel } from './job-details';
import { TransactionErrorsApiModel } from './transaction-errors';

export interface JobApiModel {
  /**
   * Automaticaly capture funds of authorized payment transactions when job finished
   */
  auto_capture_parent_transaction?: boolean;
  /**
   * Automaticaly start the job after creation
   */
  auto_start?: boolean;
  /**
   * Corporate User ID (optional)
   */
  corporate_user_id?: string;
  /**
   * Created time
   */
  created?: string;
  details?: JobDetailsApiModel;
  /**
   * Capturing transaction errors list
   */
  finalize_transaction_errors?: Array<TransactionErrorsApiModel>;
  /**
   * Flag of finalize transaction failed. Exists and set to TRUE if capture funds of authorized payment failed
   */
  finalize_transaction_failed?: boolean;
  /**
   * Сapture funds of authorized payment or cancellation transaction ID (optional)
   */
  finalize_transaction_id?: string;
  /**
   * Finished time
   */
  finished?: string;
  /**
   * Job ID
   */
  id?: string;
  /**
   * Loyalty ID (optional)
   */
  loyalty_id?: string;
  /**
   * POS ID (optional)
   */
  pos_id?: string;
  /**
   * Started time
   */
  started?: string;
  /**
   * Job status
   */
  status?: JobApiModelStatusEnum;
  /**
   * Terminal/Register ID (optional)
   */
  terminal_id?: string;
  /**
   * Linked transaction ID (optional)
   */
  transaction_id?: string;
  /**
   * Job type (required for Job creation)
   */
  type?: JobApiModelTypeEnum;
  /**
   * User ID (optional)
   */
  user_id?: string;
}
export enum JobApiModelStatusEnum {
  Created = 'created',
  Starting = 'starting',
  Inprocess = 'inprocess',
  Stopping = 'stopping',
  Finished = 'finished'
}
export enum JobApiModelTypeEnum {
  Fuel = 'fuel',
  Equipment = 'equipment'
}
